// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* font-family: "Poppins" !important; */
}

:root {
  --Text-Medium: rgba(1, 1, 2, 0.6);
}

body,
input {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  /* color: black; */
  /* color: grey; */
  border: none;
  border-color: white;
}

.disableState.MuiButtonBase-root.MuiButton-root.Mui-disabled {
  background-color: #0101020a;
}

/* .sidebar-mini .main-sidebar .nav-link {
  width: -webkit-fill-available !important;
  margin-left: 4px;
} */

.Toastify__toast-body {
  font-family: "Poppins";
}

.Toastify__toast-body div {
  width: 100%;
}

.Toastify__toast-container {
  min-height: auto;
  max-height: auto;
  padding: 14px;
  width: 374px !important;
  top: 10px !important;
}

@media only screen and (max-width: 520px) {
  .Toastify__toast-container {
    width: 100vw !important;
    margin-top: 90px !important;
    padding: 0px 25px !important;
  }

  .Toastify__toast-container--top-right {
    right: 0rem !important;
  }
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 7px;
  border-radius: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 6px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 6px;
}

@media (max-width: 520px) and (min-width: 200px) {
  .Toastify__toast-container {
    width: 280px !important;
    height: 48px !important;
    margin-top: 90px !important;
    left: 50px !important;
  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

.wrapper .content-wrapper {
  height: auto;
  min-height: auto !important;
  flex-grow: 1;
}

a:hover {
  color: var(--text-low, rgba(1, 1, 2, 0.45)) !important;
}

.nav {
  display: block;
}

.closenav {
  display: none;
}

.sidebar-collapse.sidebar-mini .main-sidebar .nav-sidebar .nav-link,
.sidebar-collapse.sidebar-mini-md .main-sidebar .nav-sidebar .nav-link,
.sidebar-collapse.sidebar-mini-xs .main-sidebar .nav-sidebar .nav-link {
  width: auto;
}

.sidebar-collapse.sidebar-mini .main-sidebar:hover .nav-child-indent .nav-link {
  width: unset;
}

.container {
  position: relative;
  width: 100%;
  background-color: #fff;
  min-height: 100vh;
  overflow: hidden;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.content {
  display: flex !important;
  padding: 0 !important;
  justify-content: center !important;
  flex-direction: column !important;
  align-items: center !important;
  margin: 32px 28px !important;
  background-color: white;
}

.mainDivCreate {
  margin-left: 0px !important;
}

.signin-signup {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 75%;
  width: 50%;
  transition: 1s 0.7s ease-in-out;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 5;
}

.MuiPaper-root.MuiPopover-paper.MuiMenu-paper {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2),
    0px 1px 8px 1px rgba(0, 0, 0, 0.14), 0px 0px 0px -4px rgba(0, 0, 0, 0.12) !important;
}

form {
  /* display: flex; */
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* padding: 0rem 5rem; */
  transition: all 0.2s 0.7s;
  overflow: hidden;
  grid-column: 1 / 1;
  grid-row: 1 / 1;
}

form.sign-up-form {
  opacity: 0;
  z-index: 1;
}

form.sign-in-form {
  z-index: 2;
}

.title {
  font-size: 2.2rem;
  color: #444;
  margin-bottom: 10px;
}

.dropdownContentStyling {
  color: var(--text-high, rgba(1, 1, 2, 0.72));
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.input-field {
  max-width: 380px;
  width: 100%;
  background-color: #f0f0f0;
  margin: 3px 0;
  height: 48px;
  border-radius: 6px;
  display: grid;
  grid-template-columns: 15% 85%;
  padding: 0 0.4rem;
  position: relative;
}

.error-field {
  max-width: 380px;
  width: 100%;
  color: #d32f2f !important;
  margin: 3px 0;
  grid-template-columns: 15% 85%;
  padding: 0 0.4rem;
  position: relative;
}

.input-field i {
  text-align: center;
  line-height: 48px;
  color: #acacac;
  transition: 0.5s;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.input-field input::placeholder {
  /*color: #aaa;*/
  font-weight: 500;
}

.social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.45rem;
  color: #333;
  border-radius: 50%;
  border: 1px solid #333;
  text-decoration: none;
  font-size: 1.1rem;
  transition: 0.3s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #4481eb;
}

.custom_btn {
  width: 150px;
  background-color: #5995fd;
  border: none;
  outline: none;
  height: 48px;
  border-radius: 48px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  cursor: pointer;
  transition: 0.5s;
}

.custom_btn:hover {
  background-color: #4d84e2;
}

.panels-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.container:before {
  content: "";
  position: absolute;
  height: 2000px;
  width: 2000px;
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  background-image: linear-gradient(-45deg, #4481eb 0%, #04befe 100%);
  transition: 1.8s ease-in-out;
  border-radius: 50%;
  z-index: 6;
}

.image {
  width: 32px;
  transition: transform 1.1s ease-in-out;
  transition-delay: 0.4s;
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  text-align: center;
  z-index: 6;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.panel .content {
  color: #fff;
  transition: transform 0.9s ease-in-out;
  transition-delay: 0.6s;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.custom_btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 150px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.right-panel .image,
.right-panel .content {
  transform: translateX(800px);
}

/* ANIMATION */

.container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .signin-signup {
  left: 25%;
}

.container.sign-up-mode form.sign-up-form {
  opacity: 1;
  z-index: 2;
}

.container.sign-up-mode form.sign-in-form {
  opacity: 0;
  z-index: 1;
}

.container.sign-up-mode .right-panel .image,
.container.sign-up-mode .right-panel .content {
  transform: translateX(0%);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

@media (max-width: 870px) {
  .container {
    min-height: 800px;
    height: 100vh;
  }

  .signin-signup {
    width: 100%;
    top: 95%;
    transform: translate(-50%, -100%);
    transition: 1s 0.8s ease-in-out;
  }

  .signin-signup,
  .container.sign-up-mode .signin-signup {
    left: 50%;
  }

  .panels-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
    grid-column: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .image {
    width: 200px;
    transition: transform 0.9s ease-in-out;
    transition-delay: 0.6s;
  }

  .panel .content {
    padding-right: 15%;
    transition: transform 0.9s ease-in-out;
    transition-delay: 0.8s;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .custom_btn.transparent {
    width: 110px;
    height: 35px;
    font-size: 0.7rem;
  }

  .container:before {
    width: 1500px;
    height: 1500px;
    transform: translateX(-50%);
    left: 30%;
    bottom: 68%;
    right: initial;
    top: initial;
    transition: 2s ease-in-out;
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .right-panel .image,
  .container.sign-up-mode .right-panel .content {
    transform: translateY(0px);
  }

  .right-panel .image,
  .right-panel .content {
    transform: translateY(300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 570px) {
  /* form {
    padding: 0 1.5rem;
  } */

  .image {
    display: none;
  }

  .panel .content {
    padding: 0.5rem 1rem;
  }

  .container {
    padding: 1.5rem;
  }

  .container:before {
    bottom: 72%;
    left: 50%;
  }

  .container.sign-up-mode:before {
    bottom: 28%;
    left: 50%;
  }
}

.otp-response {
  padding: 20px;
  height: 40vh;
  width: 450px;
  margin: 20px auto;
}

.h4-otp-response {
  text-align: center;
}

.otp-image {
  width: 50px;
  margin-left: 175px;
}

.info {
  padding: 4px 0px 0px 22px !important;
}

.react-bootstrap-table table {
  table-layout: auto !important;
}

.parent-expand-color {
  background-color: #dee2e6;
}

.table td,
.table th {
  padding: 0.2rem !important;
}

.popup-fields-width {
  width: 325px;
}

.btn-tool {
  margin: -0.34rem 0 !important;
}

.select2-container {
  margin-top: 5px;
}

.navbar {
  padding: 0;
}

.main-header {
  border-bottom: 0;
  height: 60px;
  padding: 4px;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 8px 0px rgba(62, 62, 62, 0.08);
  position: sticky;
  top: 0;
}

.main-sidebar {
  overflow-y: visible;
}

.sidebar-mini.sidebar-collapse .main-sidebar {
  overflow-x: visible;
}

.main-sidebar .brand-link {
  padding: 1.5rem;
  pointer-events: none;
}

.main-sidebar .brand-link .brand-image {
  margin-top: 16px;
  height: 72px;
  width: 32px;
  pointer-events: none;
}

.iconsSize.MuiSvgIcon-root {
  height: 24px !important;
  width: 24px !important;
}

.menuBarTitle {
  margin-left: 10px !important;
  display: flex !important;
  align-items: center !important;
}

.header-breadcrumb {}

.content-mui-wrapper {
  font-family: "Poppins" !important;
  /* padding: 40px 32px; */
}

.mui-stepper {
  max-width: 1100px;
  padding: 20px 0 28px;
}

.mui-stepper-content-container {
  padding: 40px 0 40px;
}

.MuiStepLabel-label {
  font-size: 16px !important;
}

.MuiTypography-root,
.MuiStepLabel-label,
.MuiFormLabel-root,
.MuiFormHelperText-root {
  font-family: "Poppins" !important;
}

.MuiFormLabel-root,
.MuiTypography-root:not(.main-page-title, .error-field, .login-page-title) {
  /* font-weight: 500 !important; */
  /* font-weight: 500; */
  /* color: black; */
  /* color: #547187 !important; */
  color: black;
}

.main-page-title {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600 !important;
  line-height: normal;
  letter-spacing: -0.384px;
}

.main-page-H2title {
  color: rgba(84, 113, 135, 1) !important;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.216px;
}

.RememberMeStyle {
  color: rgba(84, 113, 135, 1) !important;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 28px !important;
  /* 175% */
  letter-spacing: -0.192px !important;
}

.forgotStyle {
  color: var(--generic-primary-accent, #403e9f) !important;
  font-family: Poppins !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  letter-spacing: -0.192px !important;
}

.MuiStep-root {
  padding: 0px !important;
}

.MuiStepConnector-root {
  padding: 8px !important;
}

.MuiButton-root {
  height: 40px;
}

.MuiInputBase-root {
  width: 432px;
  height: 40px;
}

.MuiInputBase-multiline {
  height: auto !important;
}

.MuiCardContent-root,
.MuiCardActions-root {
  padding: 24px !important;
}

.MuiAutocomplete-input {
  padding: 0 !important;
  font-family: "Poppins" !important;
}

.MuiTooltip-tooltip {
  font-family: "Poppins" !important;
}

.psp-image {
  width: 60px;
  height: 32px;
  object-fit: contain;
  margin-left: 16px;
}

.brand-text {
  color: #024b99;
}

.brand-text:hover {
  color: #2572f7;
}

.login-page-logo-container {
  float: left;
  width: 44px;
  height: 50px;
  margin-top: 10px;
}

.login-page-logo-container img {
  width: 44px;
  height: 50px;
}

.nav-link {
  display: flex;
  align-items: center;
}

.active-icon {
  filter: brightness(1000%);
}

/* .nav-link-style:active,
.nav-link-style:hover {
  color: green;
} */

.nav-link.active {
  background-color: #24b7aa !important;
}

.nav-link.active:hover {
  color: #ffffff !important;
  background-color: #24b7aa !important;
}

/* .nav-link:hover {
  color: #24b7aa !important;
} */

.HideBorder.MuiPaper-root.MuiCard-root {
  box-shadow: none;
  width: min-content;
}

.RemoveHover.MuiButtonBase-root.MuiButton-root {
  box-shadow: none;
  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;
}

.RemoveHover.MuiButtonBase-root.MuiButton-root:hover {
  background-color: var(--background-disabled, rgba(1, 1, 2, 0.04));
}

.colorHover.MuiButtonBase-root.MuiButton-root:hover {
  background-color: #403e9f;
}

.MuiInputBase-input.MuiOutlinedInput-input {
  box-sizing: border-box !important;
}

.singleDateStyle .MuiInputBase-input.MuiOutlinedInput-input {
  text-transform: lowercase !important;
}

.nav-link2 {
  display: flex;
  align-items: center;
}

.nav-link2.active {
  color: black !important;
  /* box-shadow: 0px 2px 8px 0px #00000026; */
  background-color: rgb(243, 240, 240) !important;
}

.nav-link2.active:hover {
  color: gray !important;
  /* box-shadow: 0px 2px 8px 0px #00000026; */
  background-color: white !important;
}

.nav-link2:hover {
  color: black !important;
  /* box-shadow: 0px 2px 8px 0px #00000026; */
  background-color: rgb(243, 240, 240);
}

.navbar-nav {
  display: flex;
  align-items: center;
}

.MuiListItemText-root .MuiTypography-root {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
}

@media only screen and (min-width: 1001px) {
  .navbar-nav>.user-menu>.dropdown-menu {
    width: 150px;
    margin-left: 360px;
    /* margin-top: 45px; */
  }
}

@media only screen and (max-width: 1000px) {
  .navbar-nav>.user-menu>.dropdown-menu {
    width: 150px;
    margin-left: 100px;
    /* margin-top: 45px; */
  }
}

.nav-sidebar .menu-is-opening>.nav-link i.right,
.nav-sidebar .menu-is-opening>.nav-link svg.right,
.nav-sidebar .menu-open>.nav-link i.right,
.nav-sidebar .menu-open>.nav-link svg.right {
  transform: rotate(-180deg) !important;
}

.mt-2 {
  margin-top: 1.5rem !important;
}

.layout-fixed .wrapper .sidebar {
  height: calc(100vh - (5.9rem + 1px));
  padding-bottom: 20px;
}

.os-theme-light>.os-scrollbar>.os-scrollbar-track>.os-scrollbar-handle {
  background: rgba(98, 97, 97, 0.4);
}

.os-theme-light>.os-scrollbar>.os-scrollbar-track>.os-scrollbar-handle:hover {
  background: rgba(98, 97, 97, 0.4);
}

/* For the thumb (toggle) color when checked */
.customSwitch .MuiSwitch-switchBase.Mui-checked {
  color: #FFF !important;
}

/* For the track color when checked */
.customSwitch .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track {
  background-color: #262626 !important;
}

.disabledLabel {
  opacity: 0.65;
}

.dropdownCheckboxItem:hover {
  background-color: #F3F4F4 !important;
}

.roundedBorder {
  border: 1.2px solid #0101021F;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/css/style.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE;;qBAEmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE;wFACsF;AACxF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,mEAAmE;EACnE,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,cAAc;;AAEd;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,cAAc;EAChB;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,OAAO;IACP,6BAA6B;EAC/B;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,oBAAoB;;AAEpB;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,wDAAwD;EACxD,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap\");\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  /* font-family: \"Poppins\" !important; */\r\n}\r\n\r\n:root {\r\n  --Text-Medium: rgba(1, 1, 2, 0.6);\r\n}\r\n\r\nbody,\r\ninput {\r\n  font-family: \"Poppins\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\r\n    \"Segoe UI Symbol\";\r\n  /* color: black; */\r\n  /* color: grey; */\r\n  border: none;\r\n  border-color: white;\r\n}\r\n\r\n.disableState.MuiButtonBase-root.MuiButton-root.Mui-disabled {\r\n  background-color: #0101020a;\r\n}\r\n\r\n/* .sidebar-mini .main-sidebar .nav-link {\r\n  width: -webkit-fill-available !important;\r\n  margin-left: 4px;\r\n} */\r\n\r\n.Toastify__toast-body {\r\n  font-family: \"Poppins\";\r\n}\r\n\r\n.Toastify__toast-body div {\r\n  width: 100%;\r\n}\r\n\r\n.Toastify__toast-container {\r\n  min-height: auto;\r\n  max-height: auto;\r\n  padding: 14px;\r\n  width: 374px !important;\r\n  top: 10px !important;\r\n}\r\n\r\n@media only screen and (max-width: 520px) {\r\n  .Toastify__toast-container {\r\n    width: 100vw !important;\r\n    margin-top: 90px !important;\r\n    padding: 0px 25px !important;\r\n  }\r\n\r\n  .Toastify__toast-container--top-right {\r\n    right: 0rem !important;\r\n  }\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 7px;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #d9d9d9;\r\n  border-radius: 6px;\r\n}\r\n\r\n@media (max-width: 520px) and (min-width: 200px) {\r\n  .Toastify__toast-container {\r\n    width: 280px !important;\r\n    height: 48px !important;\r\n    margin-top: 90px !important;\r\n    left: 50px !important;\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100dvh;\r\n}\r\n\r\n.wrapper .content-wrapper {\r\n  height: auto;\r\n  min-height: auto !important;\r\n  flex-grow: 1;\r\n}\r\n\r\na:hover {\r\n  color: var(--text-low, rgba(1, 1, 2, 0.45)) !important;\r\n}\r\n\r\n.nav {\r\n  display: block;\r\n}\r\n\r\n.closenav {\r\n  display: none;\r\n}\r\n\r\n.sidebar-collapse.sidebar-mini .main-sidebar .nav-sidebar .nav-link,\r\n.sidebar-collapse.sidebar-mini-md .main-sidebar .nav-sidebar .nav-link,\r\n.sidebar-collapse.sidebar-mini-xs .main-sidebar .nav-sidebar .nav-link {\r\n  width: auto;\r\n}\r\n\r\n.sidebar-collapse.sidebar-mini .main-sidebar:hover .nav-child-indent .nav-link {\r\n  width: unset;\r\n}\r\n\r\n.container {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  min-height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.forms-container {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.content {\r\n  display: flex !important;\r\n  padding: 0 !important;\r\n  justify-content: center !important;\r\n  flex-direction: column !important;\r\n  align-items: center !important;\r\n  margin: 32px 28px !important;\r\n  background-color: white;\r\n}\r\n\r\n.mainDivCreate {\r\n  margin-left: 0px !important;\r\n}\r\n\r\n.signin-signup {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  left: 75%;\r\n  width: 50%;\r\n  transition: 1s 0.7s ease-in-out;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  z-index: 5;\r\n}\r\n\r\n.MuiPaper-root.MuiPopover-paper.MuiMenu-paper {\r\n  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2),\r\n    0px 1px 8px 1px rgba(0, 0, 0, 0.14), 0px 0px 0px -4px rgba(0, 0, 0, 0.12) !important;\r\n}\r\n\r\nform {\r\n  /* display: flex; */\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  /* padding: 0rem 5rem; */\r\n  transition: all 0.2s 0.7s;\r\n  overflow: hidden;\r\n  grid-column: 1 / 1;\r\n  grid-row: 1 / 1;\r\n}\r\n\r\nform.sign-up-form {\r\n  opacity: 0;\r\n  z-index: 1;\r\n}\r\n\r\nform.sign-in-form {\r\n  z-index: 2;\r\n}\r\n\r\n.title {\r\n  font-size: 2.2rem;\r\n  color: #444;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.dropdownContentStyling {\r\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.input-field {\r\n  max-width: 380px;\r\n  width: 100%;\r\n  background-color: #f0f0f0;\r\n  margin: 3px 0;\r\n  height: 48px;\r\n  border-radius: 6px;\r\n  display: grid;\r\n  grid-template-columns: 15% 85%;\r\n  padding: 0 0.4rem;\r\n  position: relative;\r\n}\r\n\r\n.error-field {\r\n  max-width: 380px;\r\n  width: 100%;\r\n  color: #d32f2f !important;\r\n  margin: 3px 0;\r\n  grid-template-columns: 15% 85%;\r\n  padding: 0 0.4rem;\r\n  position: relative;\r\n}\r\n\r\n.input-field i {\r\n  text-align: center;\r\n  line-height: 48px;\r\n  color: #acacac;\r\n  transition: 0.5s;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.input-field input {\r\n  background: none;\r\n  outline: none;\r\n  border: none;\r\n  line-height: 1;\r\n  font-weight: 600;\r\n  font-size: 1.1rem;\r\n  color: #333;\r\n}\r\n\r\n.input-field input::placeholder {\r\n  /*color: #aaa;*/\r\n  font-weight: 500;\r\n}\r\n\r\n.social-text {\r\n  padding: 0.7rem 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n.social-media {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.social-icon {\r\n  height: 46px;\r\n  width: 46px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 0.45rem;\r\n  color: #333;\r\n  border-radius: 50%;\r\n  border: 1px solid #333;\r\n  text-decoration: none;\r\n  font-size: 1.1rem;\r\n  transition: 0.3s;\r\n}\r\n\r\n.social-icon:hover {\r\n  color: #4481eb;\r\n  border-color: #4481eb;\r\n}\r\n\r\n.custom_btn {\r\n  width: 150px;\r\n  background-color: #5995fd;\r\n  border: none;\r\n  outline: none;\r\n  height: 48px;\r\n  border-radius: 48px;\r\n  color: #fff;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  margin: 10px 0;\r\n  cursor: pointer;\r\n  transition: 0.5s;\r\n}\r\n\r\n.custom_btn:hover {\r\n  background-color: #4d84e2;\r\n}\r\n\r\n.panels-container {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n\r\n.container:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 2000px;\r\n  width: 2000px;\r\n  top: -10%;\r\n  right: 48%;\r\n  transform: translateY(-50%);\r\n  background-image: linear-gradient(-45deg, #4481eb 0%, #04befe 100%);\r\n  transition: 1.8s ease-in-out;\r\n  border-radius: 50%;\r\n  z-index: 6;\r\n}\r\n\r\n.image {\r\n  width: 32px;\r\n  transition: transform 1.1s ease-in-out;\r\n  transition-delay: 0.4s;\r\n}\r\n\r\n.panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  justify-content: space-around;\r\n  text-align: center;\r\n  z-index: 6;\r\n}\r\n\r\n.left-panel {\r\n  pointer-events: all;\r\n  padding: 3rem 17% 2rem 12%;\r\n}\r\n\r\n.right-panel {\r\n  pointer-events: none;\r\n  padding: 3rem 12% 2rem 17%;\r\n}\r\n\r\n.panel .content {\r\n  color: #fff;\r\n  transition: transform 0.9s ease-in-out;\r\n  transition-delay: 0.6s;\r\n}\r\n\r\n.panel h3 {\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.panel p {\r\n  font-size: 0.95rem;\r\n  padding: 0.7rem 0;\r\n}\r\n\r\n.custom_btn.transparent {\r\n  margin: 0;\r\n  background: none;\r\n  border: 2px solid #fff;\r\n  width: 150px;\r\n  height: 41px;\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.right-panel .image,\r\n.right-panel .content {\r\n  transform: translateX(800px);\r\n}\r\n\r\n/* ANIMATION */\r\n\r\n.container.sign-up-mode:before {\r\n  transform: translate(100%, -50%);\r\n  right: 52%;\r\n}\r\n\r\n.container.sign-up-mode .left-panel .image,\r\n.container.sign-up-mode .left-panel .content {\r\n  transform: translateX(-800px);\r\n}\r\n\r\n.container.sign-up-mode .signin-signup {\r\n  left: 25%;\r\n}\r\n\r\n.container.sign-up-mode form.sign-up-form {\r\n  opacity: 1;\r\n  z-index: 2;\r\n}\r\n\r\n.container.sign-up-mode form.sign-in-form {\r\n  opacity: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.container.sign-up-mode .right-panel .image,\r\n.container.sign-up-mode .right-panel .content {\r\n  transform: translateX(0%);\r\n}\r\n\r\n.container.sign-up-mode .left-panel {\r\n  pointer-events: none;\r\n}\r\n\r\n.container.sign-up-mode .right-panel {\r\n  pointer-events: all;\r\n}\r\n\r\n@media (max-width: 870px) {\r\n  .container {\r\n    min-height: 800px;\r\n    height: 100vh;\r\n  }\r\n\r\n  .signin-signup {\r\n    width: 100%;\r\n    top: 95%;\r\n    transform: translate(-50%, -100%);\r\n    transition: 1s 0.8s ease-in-out;\r\n  }\r\n\r\n  .signin-signup,\r\n  .container.sign-up-mode .signin-signup {\r\n    left: 50%;\r\n  }\r\n\r\n  .panels-container {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr 2fr 1fr;\r\n  }\r\n\r\n  .panel {\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    padding: 2.5rem 8%;\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .right-panel {\r\n    grid-row: 3 / 4;\r\n  }\r\n\r\n  .left-panel {\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .image {\r\n    width: 200px;\r\n    transition: transform 0.9s ease-in-out;\r\n    transition-delay: 0.6s;\r\n  }\r\n\r\n  .panel .content {\r\n    padding-right: 15%;\r\n    transition: transform 0.9s ease-in-out;\r\n    transition-delay: 0.8s;\r\n  }\r\n\r\n  .panel h3 {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .panel p {\r\n    font-size: 0.7rem;\r\n    padding: 0.5rem 0;\r\n  }\r\n\r\n  .custom_btn.transparent {\r\n    width: 110px;\r\n    height: 35px;\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .container:before {\r\n    width: 1500px;\r\n    height: 1500px;\r\n    transform: translateX(-50%);\r\n    left: 30%;\r\n    bottom: 68%;\r\n    right: initial;\r\n    top: initial;\r\n    transition: 2s ease-in-out;\r\n  }\r\n\r\n  .container.sign-up-mode:before {\r\n    transform: translate(-50%, 100%);\r\n    bottom: 32%;\r\n    right: initial;\r\n  }\r\n\r\n  .container.sign-up-mode .left-panel .image,\r\n  .container.sign-up-mode .left-panel .content {\r\n    transform: translateY(-300px);\r\n  }\r\n\r\n  .container.sign-up-mode .right-panel .image,\r\n  .container.sign-up-mode .right-panel .content {\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  .right-panel .image,\r\n  .right-panel .content {\r\n    transform: translateY(300px);\r\n  }\r\n\r\n  .container.sign-up-mode .signin-signup {\r\n    top: 5%;\r\n    transform: translate(-50%, 0);\r\n  }\r\n}\r\n\r\n@media (max-width: 570px) {\r\n  /* form {\r\n    padding: 0 1.5rem;\r\n  } */\r\n\r\n  .image {\r\n    display: none;\r\n  }\r\n\r\n  .panel .content {\r\n    padding: 0.5rem 1rem;\r\n  }\r\n\r\n  .container {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .container:before {\r\n    bottom: 72%;\r\n    left: 50%;\r\n  }\r\n\r\n  .container.sign-up-mode:before {\r\n    bottom: 28%;\r\n    left: 50%;\r\n  }\r\n}\r\n\r\n.otp-response {\r\n  padding: 20px;\r\n  height: 40vh;\r\n  width: 450px;\r\n  margin: 20px auto;\r\n}\r\n\r\n.h4-otp-response {\r\n  text-align: center;\r\n}\r\n\r\n.otp-image {\r\n  width: 50px;\r\n  margin-left: 175px;\r\n}\r\n\r\n.info {\r\n  padding: 4px 0px 0px 22px !important;\r\n}\r\n\r\n.react-bootstrap-table table {\r\n  table-layout: auto !important;\r\n}\r\n\r\n.parent-expand-color {\r\n  background-color: #dee2e6;\r\n}\r\n\r\n.table td,\r\n.table th {\r\n  padding: 0.2rem !important;\r\n}\r\n\r\n.popup-fields-width {\r\n  width: 325px;\r\n}\r\n\r\n.btn-tool {\r\n  margin: -0.34rem 0 !important;\r\n}\r\n\r\n.select2-container {\r\n  margin-top: 5px;\r\n}\r\n\r\n.navbar {\r\n  padding: 0;\r\n}\r\n\r\n.main-header {\r\n  border-bottom: 0;\r\n  height: 60px;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  box-shadow: 0px 2px 8px 0px rgba(62, 62, 62, 0.08);\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n\r\n.main-sidebar {\r\n  overflow-y: visible;\r\n}\r\n\r\n.sidebar-mini.sidebar-collapse .main-sidebar {\r\n  overflow-x: visible;\r\n}\r\n\r\n.main-sidebar .brand-link {\r\n  padding: 1.5rem;\r\n  pointer-events: none;\r\n}\r\n\r\n.main-sidebar .brand-link .brand-image {\r\n  margin-top: 16px;\r\n  height: 72px;\r\n  width: 32px;\r\n  pointer-events: none;\r\n}\r\n\r\n.iconsSize.MuiSvgIcon-root {\r\n  height: 24px !important;\r\n  width: 24px !important;\r\n}\r\n\r\n.menuBarTitle {\r\n  margin-left: 10px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.header-breadcrumb {}\r\n\r\n.content-mui-wrapper {\r\n  font-family: \"Poppins\" !important;\r\n  /* padding: 40px 32px; */\r\n}\r\n\r\n.mui-stepper {\r\n  max-width: 1100px;\r\n  padding: 20px 0 28px;\r\n}\r\n\r\n.mui-stepper-content-container {\r\n  padding: 40px 0 40px;\r\n}\r\n\r\n.MuiStepLabel-label {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.MuiTypography-root,\r\n.MuiStepLabel-label,\r\n.MuiFormLabel-root,\r\n.MuiFormHelperText-root {\r\n  font-family: \"Poppins\" !important;\r\n}\r\n\r\n.MuiFormLabel-root,\r\n.MuiTypography-root:not(.main-page-title, .error-field, .login-page-title) {\r\n  /* font-weight: 500 !important; */\r\n  /* font-weight: 500; */\r\n  /* color: black; */\r\n  /* color: #547187 !important; */\r\n  color: black;\r\n}\r\n\r\n.main-page-title {\r\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\r\n  font-family: Poppins;\r\n  font-size: 32px;\r\n  font-style: normal;\r\n  font-weight: 600 !important;\r\n  line-height: normal;\r\n  letter-spacing: -0.384px;\r\n}\r\n\r\n.main-page-H2title {\r\n  color: rgba(84, 113, 135, 1) !important;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 28px;\r\n  letter-spacing: -0.216px;\r\n}\r\n\r\n.RememberMeStyle {\r\n  color: rgba(84, 113, 135, 1) !important;\r\n  font-family: Poppins !important;\r\n  font-size: 16px !important;\r\n  font-style: normal;\r\n  font-weight: 500 !important;\r\n  line-height: 28px !important;\r\n  /* 175% */\r\n  letter-spacing: -0.192px !important;\r\n}\r\n\r\n.forgotStyle {\r\n  color: var(--generic-primary-accent, #403e9f) !important;\r\n  font-family: Poppins !important;\r\n  font-size: 14px !important;\r\n  font-style: normal !important;\r\n  font-weight: 500 !important;\r\n  line-height: 24px !important;\r\n  letter-spacing: -0.192px !important;\r\n}\r\n\r\n.MuiStep-root {\r\n  padding: 0px !important;\r\n}\r\n\r\n.MuiStepConnector-root {\r\n  padding: 8px !important;\r\n}\r\n\r\n.MuiButton-root {\r\n  height: 40px;\r\n}\r\n\r\n.MuiInputBase-root {\r\n  width: 432px;\r\n  height: 40px;\r\n}\r\n\r\n.MuiInputBase-multiline {\r\n  height: auto !important;\r\n}\r\n\r\n.MuiCardContent-root,\r\n.MuiCardActions-root {\r\n  padding: 24px !important;\r\n}\r\n\r\n.MuiAutocomplete-input {\r\n  padding: 0 !important;\r\n  font-family: \"Poppins\" !important;\r\n}\r\n\r\n.MuiTooltip-tooltip {\r\n  font-family: \"Poppins\" !important;\r\n}\r\n\r\n.psp-image {\r\n  width: 60px;\r\n  height: 32px;\r\n  object-fit: contain;\r\n  margin-left: 16px;\r\n}\r\n\r\n.brand-text {\r\n  color: #024b99;\r\n}\r\n\r\n.brand-text:hover {\r\n  color: #2572f7;\r\n}\r\n\r\n.login-page-logo-container {\r\n  float: left;\r\n  width: 44px;\r\n  height: 50px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.login-page-logo-container img {\r\n  width: 44px;\r\n  height: 50px;\r\n}\r\n\r\n.nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.active-icon {\r\n  filter: brightness(1000%);\r\n}\r\n\r\n/* .nav-link-style:active,\r\n.nav-link-style:hover {\r\n  color: green;\r\n} */\r\n\r\n.nav-link.active {\r\n  background-color: #24b7aa !important;\r\n}\r\n\r\n.nav-link.active:hover {\r\n  color: #ffffff !important;\r\n  background-color: #24b7aa !important;\r\n}\r\n\r\n/* .nav-link:hover {\r\n  color: #24b7aa !important;\r\n} */\r\n\r\n.HideBorder.MuiPaper-root.MuiCard-root {\r\n  box-shadow: none;\r\n  width: min-content;\r\n}\r\n\r\n.RemoveHover.MuiButtonBase-root.MuiButton-root {\r\n  box-shadow: none;\r\n  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;\r\n}\r\n\r\n.RemoveHover.MuiButtonBase-root.MuiButton-root:hover {\r\n  background-color: var(--background-disabled, rgba(1, 1, 2, 0.04));\r\n}\r\n\r\n.colorHover.MuiButtonBase-root.MuiButton-root:hover {\r\n  background-color: #403e9f;\r\n}\r\n\r\n.MuiInputBase-input.MuiOutlinedInput-input {\r\n  box-sizing: border-box !important;\r\n}\r\n\r\n.singleDateStyle .MuiInputBase-input.MuiOutlinedInput-input {\r\n  text-transform: lowercase !important;\r\n}\r\n\r\n.nav-link2 {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.nav-link2.active {\r\n  color: black !important;\r\n  /* box-shadow: 0px 2px 8px 0px #00000026; */\r\n  background-color: rgb(243, 240, 240) !important;\r\n}\r\n\r\n.nav-link2.active:hover {\r\n  color: gray !important;\r\n  /* box-shadow: 0px 2px 8px 0px #00000026; */\r\n  background-color: white !important;\r\n}\r\n\r\n.nav-link2:hover {\r\n  color: black !important;\r\n  /* box-shadow: 0px 2px 8px 0px #00000026; */\r\n  background-color: rgb(243, 240, 240);\r\n}\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.MuiListItemText-root .MuiTypography-root {\r\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n@media only screen and (min-width: 1001px) {\r\n  .navbar-nav>.user-menu>.dropdown-menu {\r\n    width: 150px;\r\n    margin-left: 360px;\r\n    /* margin-top: 45px; */\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1000px) {\r\n  .navbar-nav>.user-menu>.dropdown-menu {\r\n    width: 150px;\r\n    margin-left: 100px;\r\n    /* margin-top: 45px; */\r\n  }\r\n}\r\n\r\n.nav-sidebar .menu-is-opening>.nav-link i.right,\r\n.nav-sidebar .menu-is-opening>.nav-link svg.right,\r\n.nav-sidebar .menu-open>.nav-link i.right,\r\n.nav-sidebar .menu-open>.nav-link svg.right {\r\n  transform: rotate(-180deg) !important;\r\n}\r\n\r\n.mt-2 {\r\n  margin-top: 1.5rem !important;\r\n}\r\n\r\n.layout-fixed .wrapper .sidebar {\r\n  height: calc(100vh - (5.9rem + 1px));\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.os-theme-light>.os-scrollbar>.os-scrollbar-track>.os-scrollbar-handle {\r\n  background: rgba(98, 97, 97, 0.4);\r\n}\r\n\r\n.os-theme-light>.os-scrollbar>.os-scrollbar-track>.os-scrollbar-handle:hover {\r\n  background: rgba(98, 97, 97, 0.4);\r\n}\r\n\r\n/* For the thumb (toggle) color when checked */\r\n.customSwitch .MuiSwitch-switchBase.Mui-checked {\r\n  color: #FFF !important;\r\n}\r\n\r\n/* For the track color when checked */\r\n.customSwitch .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track {\r\n  background-color: #262626 !important;\r\n}\r\n\r\n.disabledLabel {\r\n  opacity: 0.65;\r\n}\r\n\r\n.dropdownCheckboxItem:hover {\r\n  background-color: #F3F4F4 !important;\r\n}\r\n\r\n.roundedBorder {\r\n  border: 1.2px solid #0101021F;\r\n  border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
